import script from "./DialogManualMonitor.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogManualMonitor.vue?vue&type=script&setup=true&lang=ts"

import "./DialogManualMonitor.vue?vue&type=style&index=0&id=9572527e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9572527e"]])

export default __exports__